import Loader from 'components/Loader'

const PageLoader = () => {
  return (
    <main className="main-content">
      <div className='main-content__left'></div>
      <div className='main-content__right'>
        <Loader />
      </div>
    </main>
  )
}

export default PageLoader
